import React from "react";
import SEO from "../components/SEO";
import { TextSection, SectionContent } from "../components/Section";

export default function DatenschutzPage() {
  return (
    <>
      <SEO title="Datenschutz" />

      <TextSection>
        <SectionContent>
          <h1>Datenschutzerkl&auml;rung</h1>

          <h2>1. Datenschutz auf einen Blick</h2>

          <h3>Allgemeine Hinweise</h3>

          <p>
            Die folgenden Hinweise geben einen einfachen &Uuml;berblick
            dar&uuml;ber, was mit Ihren personenbezogenen Daten passiert, wenn
            Sie diese Website besuchen. Personenbezogene Daten sind alle Daten,
            mit denen Sie pers&ouml;nlich identifiziert werden k&ouml;nnen.
            Ausf&uuml;hrliche Informationen zum Thema Datenschutz entnehmen Sie
            unserer unter diesem Text aufgef&uuml;hrten
            Datenschutzerkl&auml;rung.
          </p>

          <h3>Datenerfassung auf dieser Website</h3>

          <p>
            <strong>
              Wer ist verantwortlich f&uuml;r die Datenerfassung auf dieser
              Website?
            </strong>
          </p>

          <p>
            Die Datenverarbeitung auf dieser Website erfolgt durch den
            Websitebetreiber. Dessen Kontaktdaten k&ouml;nnen Sie dem Abschnitt
            &bdquo;Hinweis zur Verantwortlichen Stelle&ldquo; in dieser
            Datenschutzerkl&auml;rung entnehmen.&nbsp;
          </p>

          <p>
            <strong>Wie erfassen wir Ihre Daten?</strong>
          </p>

          <p>
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
            mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in
            ein Kontaktformular eingeben. Andere Daten werden automatisch oder
            nach Ihrer Einwilligung beim Besuch der Website durch unsere
            ITSysteme erfasst. Das sind vor allem technische Daten (z. B.
            Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
            Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website
            betreten.
          </p>

          <p>
            <strong>Wof&uuml;r nutzen wir Ihre Daten?</strong>
          </p>

          <p>
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
            der Website zu gew&auml;hrleisten. Andere Daten k&ouml;nnen zur
            Analyse Ihres Nutzerverhaltens verwendet werden.
          </p>

          <p>
            <strong>Welche Rechte haben Sie bez&uuml;glich Ihrer Daten?</strong>
          </p>

          <p>
            Sie haben jederzeit das Recht, unentgeltlich Auskunft &uuml;ber
            Herkunft, Empf&auml;nger und Zweck Ihrer gespeicherten
            personenbezogenen Daten zu erhalten. Sie haben au&szlig;erdem ein
            Recht, die Berichtigung oder L&ouml;schung dieser Daten zu
            verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt
            haben, k&ouml;nnen Sie diese Einwilligung jederzeit f&uuml;r die
            Zukunft widerrufen. Au&szlig;erdem haben Sie das Recht, unter
            bestimmten Umst&auml;nden die Einschr&auml;nkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
            ein Beschwerderecht bei der zust&auml;ndigen Aufsichtsbeh&ouml;rde
            zu. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz
            k&ouml;nnen Sie sich jederzeit an uns wenden.
          </p>

          <h3>Analyse-Tools und Tools von Drittanbietern</h3>

          <p>
            Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
            ausgewertet werden. Das geschieht vor allem mit sogenannten
            Analyseprogrammen. Detaillierte Informationen zu diesen
            Analyseprogrammen finden Sie in der folgenden
            Datenschutzerkl&auml;rung.
          </p>

          <h2>2. Hosting</h2>

          <p>
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            Alfahosting
          </p>

          <p>
            Anbieter ist die Alfahosting GmbH, Ankerstra&szlig;e 3b, 06108 Halle
            (Saale) (nachfolgend Alfahosting) Wenn Sie unsere Website besuchen,
            erfasst Alfahosting verschiedene Logfiles inklusive Ihrer
            IP-Adressen.
          </p>

          <p>
            Details entnehmen Sie der Datenschutzerkl&auml;rung von Alfahosting:
          </p>

          <p>
            <a href="https://alfahosting.de/datenschutz/">
              https://alfahosting.de/datenschutz/
            </a>
            .
          </p>

          <p>
            Die Verwendung von Alfahosting erfolgt auf Grundlage von Art. 6 Abs.
            1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer
            m&ouml;glichst zuverl&auml;ssigen Darstellung unserer Website.
            Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1
            lit. a DSGVO und &sect; 25 Abs. 1 TTDSG, soweit die Einwilligung die
            Speicherung von Cookies oder den Zugriff auf Informationen im
            Endger&auml;t des Nutzers (z. B. f&uuml;r Device-Fingerprinting) im
            Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.
          </p>

          <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>

          <h3>Datenschutz</h3>

          <p>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer
            pers&ouml;nlichen Daten sehr ernst. Wir behandeln Ihre
            personenbezogenen Daten vertraulich und entsprechend den
            gesetzlichen Datenschutzvorschriften sowie dieser
            Datenschutzerkl&auml;rung.&nbsp;
          </p>

          <p>
            Wenn Sie diese Website benutzen, werden verschiedene
            personenbezogene Daten erhoben.
          </p>

          <p>
            Personenbezogene Daten sind Daten, mit denen Sie pers&ouml;nlich
            identifiziert werden k&ouml;nnen. Die vorliegende
            Datenschutzerkl&auml;rung erl&auml;utert, welche Daten wir erheben
            und wof&uuml;r wir sie nutzen. Sie erl&auml;utert auch, wie und zu
            welchem Zweck das geschieht.
          </p>

          <p>
            Wir weisen darauf hin, dass die Daten&uuml;bertragung im Internet
            (z. B. bei der Kommunikation per E-Mail) Sicherheitsl&uuml;cken
            aufweisen kann. Ein l&uuml;ckenloser Schutz der Daten vor dem
            Zugriff durch Dritte ist nicht m&ouml;glich.
          </p>

          <h3>Hinweis zur verantwortlichen Stelle</h3>

          <p>
            Die verantwortliche Stelle f&uuml;r die Datenverarbeitung auf dieser
            Website ist:
          </p>

          <p>
            Herzkraft Yoga | Nadine Seuffert
            <br />
            Windthorststr. 28a
            <br />
            67346 Speyer
            <br />
            Telefon: [auf Anfrage]
            <br />
            E-Mail:{" "}
            <a href="mailto:herzkraft@nadineseuffert.com">
              herzkraft@nadineseuffert.com
            </a>
            &nbsp;
          </p>

          <p>
            Verantwortliche Stelle ist die nat&uuml;rliche oder juristische
            Person, die allein oder gemeinsam mit anderen &uuml;ber die Zwecke
            und Mittel der Verarbeitung von personenbezogenen Daten (z. B.
            Namen, E-Mail-Adressen o. &Auml;.) entscheidet.
          </p>

          <h3>Speicherdauer</h3>

          <p>
            Soweit innerhalb dieser Datenschutzerkl&auml;rung keine speziellere
            Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
            bei uns, bis der Zweck f&uuml;r die Datenverarbeitung entf&auml;llt.
            Wenn Sie ein berechtigtes L&ouml;schersuchen geltend machen oder
            eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre
            Daten gel&ouml;scht, sofern wir keine anderen rechtlich
            zul&auml;ssigen Gr&uuml;nde f&uuml;r die Speicherung Ihrer
            personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
            Aufbewahrungsfristen); im letztgenannten Fall erfolgt die
            L&ouml;schung nach Fortfall dieser Gr&uuml;nde.
          </p>

          <h3>
            Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung
            auf dieser Website
          </h3>

          <p>
            Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten
            wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1
            lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
            Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im
            Falle einer ausdr&uuml;cklichen Einwilligung in die &Uuml;bertragung
            personenbezogener Daten in Drittstaaten erfolgt die
            Datenverarbeitung au&szlig;erdem auf Grundlage von Art.
          </p>

          <p>
            49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies
            oder in den Zugriff auf Informationen in Ihr Endger&auml;t (z. B.
            via Device-Fingerprinting) eingewilligt haben, erfolgt die
            Datenverarbeitung zus&auml;tzlich auf Grundlage von &sect; 25 Abs. 1
            TTDSG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten
            zur Vertragserf&uuml;llung oder zur Durchf&uuml;hrung
            vorvertraglicher Ma&szlig;nahmen erforderlich, verarbeiten wir Ihre
            Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren
            verarbeiten wir Ihre Daten, sofern diese zur Erf&uuml;llung einer
            rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6
            Abs. 1 lit. c DSGVO.
          </p>

          <p>
            Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten
            Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. &Uuml;ber die
            jeweils im Einzelfall einschl&auml;gigen Rechtsgrundlagen wird in
            den folgenden Abs&auml;tzen dieser Datenschutzerkl&auml;rung
            informiert.
          </p>

          <h3>
            Hinweis zur Datenweitergabe in die USA und sonstige Drittstaaten
          </h3>

          <p>
            Wir verwenden unter anderem Tools von Unternehmen mit Sitz in den
            USA oder sonstigen datenschutzrechtlich nicht sicheren Drittstaaten.
            Wenn diese Tools aktiv sind, k&ouml;nnen Ihre personenbezogene Daten
            in diese Drittstaaten &uuml;bertragen und dort verarbeitet werden.
            Wir weisen darauf hin, dass in diesen L&auml;ndern kein mit der EU
            vergleichbares Datenschutzniveau garantiert werden kann.
          </p>

          <p>
            Beispielsweise sind US-Unternehmen dazu verpflichtet,
            personenbezogene Daten an Sicherheitsbeh&ouml;rden herauszugeben,
            ohne dass Sie als Betroffener hiergegen gerichtlich vorgehen
            k&ouml;nnten. Es kann daher nicht ausgeschlossen werden, dass
            US-Beh&ouml;rden (z. B. Geheimdienste) Ihre auf US-Servern
            befindlichen Daten zu &Uuml;berwachungszwecken verarbeiten,
            auswerten und dauerhaft speichern. Wir haben auf diese
            Verarbeitungst&auml;tigkeiten keinen Einfluss.
          </p>

          <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>

          <p>
            Viele Datenverarbeitungsvorg&auml;nge sind nur mit Ihrer
            ausdr&uuml;cklichen Einwilligung m&ouml;glich. Sie k&ouml;nnen eine
            bereits erteilte Einwilligung jederzeit widerrufen. Die
            Rechtm&auml;&szlig;igkeit der bis zum Widerruf erfolgten
            Datenverarbeitung bleibt vom Widerruf unber&uuml;hrt.
          </p>

          <p>
            Widerspruchsrecht gegen die Datenerhebung in besonderen F&auml;llen
            sowie gegen Direktwerbung (Art. 21 DSGVO)
          </p>

          <p>
            WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E
            ODER F DSGVO&nbsp;ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS
            GR&Uuml;NDEN, DIE SICH AUS IHRER BESONDEREN&nbsp;SITUATION ERGEBEN,
            GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN
            DATEN&nbsp;WIDERSPRUCH EINZULEGEN; DIES GILT AUCH F&Uuml;R EIN AUF
            DIESE BESTIMMUNGEN GEST&Uuml;TZTES&nbsp;PROFILING. DIE JEWEILIGE
            RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,&nbsp;ENTNEHMEN
            SIE DIESER DATENSCHUTZERKL&Auml;RUNG. WENN SIE WIDERSPRUCH
            EINLEGEN,&nbsp;WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN
            NICHT MEHR VERARBEITEN, ES&nbsp;SEI DENN, WIR K&Ouml;NNEN ZWINGENDE
            SCHUTZW&Uuml;RDIGE GR&Uuml;NDE F&Uuml;R DIE
            VERARBEITUNG&nbsp;NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND
            FREIHEITEN &Uuml;BERWIEGEN ODER DIE&nbsp;VERARBEITUNG DIENT DER
            GELTENDMACHUNG, AUS&Uuml;BUNG ODER VERTEIDIGUNG
            VON&nbsp;RECHTSANSPR&Uuml;CHEN (WIDERSPRUCH NACH ART. 21 ABS. 1
            DSGVO).&nbsp;WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM
            DIREKTWERBUNG ZU BETREIBEN,&nbsp;SO HABEN SIE DAS RECHT, JEDERZEIT
            WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE&nbsp;BETREFFENDER
            PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER
            WERBUNG&nbsp;EINZULEGEN; DIES GILT AUCH F&Uuml;R DAS PROFILING,
            SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN&nbsp;VERBINDUNG STEHT. WENN
            SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN
            DATEN&nbsp;ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG
            VERWENDET (WIDERSPRUCH&nbsp;NACH ART. 21 ABS. 2 DSGVO).
          </p>

          <h3>
            Beschwerderecht bei der zust&auml;ndigen Aufsichtsbeh&ouml;rde
          </h3>

          <p>
            Im Falle von Verst&ouml;&szlig;en gegen die DSGVO steht den
            Betroffenen ein Beschwerderecht bei einer Aufsichtsbeh&ouml;rde,
            insbesondere in dem Mitgliedstaat ihres gew&ouml;hnlichen
            Aufenthalts, ihres Arbeitsplatzes oder des Orts des
            mutma&szlig;lichen Versto&szlig;es zu. Das Beschwerderecht besteht
            unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher
            Rechtsbehelfe.
          </p>

          <h3>Recht auf Daten&uuml;bertragbarkeit</h3>

          <p>
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
            oder in Erf&uuml;llung eines Vertrags automatisiert verarbeiten, an
            sich oder an einen Dritten in einem g&auml;ngigen, maschinenlesbaren
            Format aush&auml;ndigen zu lassen. Sofern Sie die direkte
            &Uuml;bertragung der Daten an einen anderen Verantwortlichen
            verlangen, erfolgt dies nur, soweit es technisch machbar ist.
          </p>

          <h3>Auskunft, Berichtigung und L&ouml;schung</h3>

          <p>
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
            jederzeit das Recht auf unentgeltliche Auskunft &uuml;ber Ihre
            gespeicherten personenbezogenen Daten, deren Herkunft und
            Empf&auml;nger und den Zweck der Datenverarbeitung und ggf. ein
            Recht auf Berichtigung oder L&ouml;schung dieser Daten. Hierzu sowie
            zu weiteren Fragen zum Thema personenbezogene Daten k&ouml;nnen Sie
            sich jederzeit an uns wenden.
          </p>

          <h3>Recht auf Einschr&auml;nkung der Verarbeitung</h3>

          <p>
            Sie haben das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen. Hierzu k&ouml;nnen Sie sich
            jederzeit an uns wenden. Das Recht auf Einschr&auml;nkung der
            Verarbeitung besteht in folgenden F&auml;llen:
          </p>

          <p>
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
            personenbezogenen Daten bestreiten, ben&ouml;tigen wir in der Regel
            Zeit, um dies zu &uuml;berpr&uuml;fen. F&uuml;r die Dauer der
            Pr&uuml;fung haben Sie das Recht, die Einschr&auml;nkung der
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </p>

          <p>
            Wenn die Verarbeitung Ihrer personenbezogenen Daten
            unrechtm&auml;&szlig;ig geschah/geschieht, k&ouml;nnen Sie statt der
            L&ouml;schung die Einschr&auml;nkung der Datenverarbeitung
            verlangen.
          </p>

          <p>
            Wenn wir Ihre personenbezogenen Daten nicht mehr ben&ouml;tigen, Sie
            sie jedoch zur Aus&uuml;bung, Verteidigung oder Geltendmachung von
            Rechtsanspr&uuml;chen ben&ouml;tigen, haben Sie das Recht, statt
            der&nbsp;L&ouml;schung die Einschr&auml;nkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen.
          </p>

          <p>
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt
            haben, muss eine Abw&auml;gung zwischen Ihren und unseren Interessen
            vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
            &uuml;berwiegen, haben Sie das Recht, die Einschr&auml;nkung der
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </p>

          <p>
            Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten
            eingeschr&auml;nkt haben, d&uuml;rfen diese Daten &ndash; von ihrer
            Speicherung abgesehen &ndash; nur mit Ihrer Einwilligung oder zur
            Geltendmachung, Aus&uuml;bung oder Verteidigung von
            Rechtsanspr&uuml;chen oder zum Schutz der Rechte einer anderen
            nat&uuml;rlichen oder juristischen Person oder aus Gr&uuml;nden
            eines wichtigen &ouml;ffentlichen Interesses der Europ&auml;ischen
            Union oder eines Mitgliedstaats verarbeitet werden.
          </p>

          <h3>SSL- bzw. TLS-Verschl&uuml;sselung</h3>

          <p>
            Diese Seite nutzt aus Sicherheitsgr&uuml;nden und zum Schutz der
            &Uuml;bertragung vertraulicher Inhalte, wie zum Beispiel
            Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber
            senden, eine SSL- bzw. TLSVerschl&uuml;sselung. Eine
            verschl&uuml;sselte Verbindung erkennen Sie daran, dass die
            Adresszeile des Browsers von &bdquo;http://&ldquo; auf
            &bdquo;https://&ldquo; wechselt und an dem Schloss-Symbol in Ihrer
            Browserzeile.
          </p>

          <p>
            Wenn die SSL- bzw. TLS-Verschl&uuml;sselung aktiviert ist,
            k&ouml;nnen die Daten, die Sie an uns &uuml;bermitteln, nicht von
            Dritten mitgelesen werden.
          </p>

          <h2>4. Datenerfassung auf dieser Website</h2>

          <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>

          <p>
            Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird
            Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen
            Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei
            uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne
            Ihre Einwilligung weiter.
          </p>

          <p>
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs.
            1 lit. b DSGVO, sofern Ihre Anfrage mit der Erf&uuml;llung eines
            Vertrags zusammenh&auml;ngt oder zur Durchf&uuml;hrung
            vorvertraglicher Ma&szlig;nahmen erforderlich ist. In allen
            &uuml;brigen F&auml;llen beruht die Verarbeitung auf unserem
            berechtigten Interesse an der effektiven Bearbeitung der an uns
            gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
            Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt
            wurde; die Einwilligung ist jederzeit widerrufbar.
          </p>

          <p>
            Die von Ihnen an uns per Kontaktanfragen &uuml;bersandten Daten
            verbleiben bei uns, bis Sie uns zur L&ouml;schung auffordern, Ihre
            Einwilligung zur Speicherung widerrufen oder der Zweck f&uuml;r die
            Datenspeicherung entf&auml;llt (z. B. nach abgeschlossener
            Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen
            &ndash; insbesondere gesetzliche Aufbewahrungsfristen &ndash;
            bleiben unber&uuml;hrt.
          </p>

          <h2>5. Plugins und Tools</h2>

          <h3>Google Analytics</h3>

          <p>
            Wir setzen auf Grundlage unserer berechtigten Interessen (d.h.
            Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb
            unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO)
            Google Analytics, einen Webanalysedienst der Google LLC
            (&bdquo;Google&ldquo;) ein. Google verwendet Cookies. Die durch das
            Cookie erzeugten Informationen &uuml;ber Benutzung des
            Onlineangebotes durch die Nutzer werden in der Regel an einen Server
            von Google in den USA &uuml;bertragen und dort gespeichert.&nbsp;
          </p>

          <p>
            Google ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet
            hierdurch eine Garantie, das europ&auml;ische Datenschutzrecht
            einzuhalten (
            <a href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&amp;status=Active">
              https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&amp;status=Active
            </a>
            ).
          </p>

          <p>
            Google wird diese Informationen in unserem Auftrag benutzen, um die
            Nutzung unseres Onlineangebotes durch die Nutzer auszuwerten, um
            Reports &uuml;ber die Aktivit&auml;ten innerhalb dieses
            Onlineangebotes zusammenzustellen und um weitere, mit der Nutzung
            dieses Onlineangebotes und der Internetnutzung verbundene
            Dienstleistungen, uns gegen&uuml;ber zu erbringen. Dabei k&ouml;nnen
            aus den verarbeiteten Daten pseudonyme Nutzungsprofile der Nutzer
            erstellt werden.
          </p>

          <p>
            Wir setzen Google Analytics nur mit aktivierter IP-Anonymisierung
            ein. Das bedeutet, die IP-Adresse der Nutzer wird von Google
            innerhalb von Mitgliedstaaten der Europ&auml;ischen Union oder in
            anderen Vertragsstaaten des Abkommens &uuml;ber den
            Europ&auml;ischen Wirtschaftsraum gek&uuml;rzt. Nur in
            Ausnahmef&auml;llen wird die volle IP-Adresse an einen Server von
            Google in den USA &uuml;bertragen und dort gek&uuml;rzt.&nbsp;
          </p>

          <p>
            Die von dem Browser des Nutzers &uuml;bermittelte IP-Adresse wird
            nicht mit anderen Daten von Google zusammengef&uuml;hrt. Die Nutzer
            k&ouml;nnen die Speicherung der Cookies durch eine entsprechende
            Einstellung ihrer Browser-Software verhindern; die Nutzer
            k&ouml;nnen dar&uuml;ber hinaus die Erfassung der durch das Cookie
            erzeugten und auf ihre Nutzung des Onlineangebotes bezogenen Daten
            an Google sowie die Verarbeitung dieser Daten durch Google
            verhindern, indem sie das unter folgendem Link verf&uuml;gbare
            Browser-Plugin herunterladen und installieren:{" "}
            <a href="http://tools.google.com/dlpage/gaoptout?hl=de">
              http://tools.google.com/dlpage/gaoptout?hl=de
            </a>
            .
          </p>

          <p>
            Weitere Informationen zur Datennutzung durch Google, Einstellungs-
            und Widerspruchsm&ouml;glichkeiten, erfahren Sie in der
            Datenschutzerkl&auml;rung von Google (
            <a href="https://policies.google.com/technologies/ads">
              https://policies.google.com/technologies/ads
            </a>
            ) sowie in den Einstellungen f&uuml;r die Darstellung von
            Werbeeinblendungen durch Google (
            <a href="https://adssettings.google.com/authenticated">
              https://adssettings.google.com/authenticated
            </a>
            ).
          </p>

          <p>
            Die personenbezogenen Daten der Nutzer werden nach 14 Monaten
            gel&ouml;scht oder anonymisiert.
          </p>

          <h3>Font Awesome</h3>

          <p>
            Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten und
            Symbolen Font Awesome. Anbieter ist die Fonticons, Inc., 6 Porter
            Road Apartment 3R, Cambridge, Massachusetts, USA. Beim Aufruf einer
            Seite l&auml;dt Ihr Browser die ben&ouml;tigten Fonts in ihren
            Browsercache, um Texte, Schriftarten und Symbole korrekt anzuzeigen.
            Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu
            den Servern von Font Awesome aufnehmen. Hierdurch erlangt Font
            Awesome Kenntnis dar&uuml;ber, dass &uuml;ber Ihre IP-Adresse diese
            Website aufgerufen wurde. Die Nutzung von Font Awesome erfolgt auf
            Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes
            Interesse an der einheitlichen Darstellung des Schriftbildes auf
            unserer Website. Sofern eine entsprechende Einwilligung abgefragt
            wurde, erfolgt die Verarbeitung ausschlie&szlig;lich auf Grundlage
            von Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TTDSG, soweit
            die Einwilligung die Speicherung von Cookies oder den Zugriff auf
            Informationen im Endger&auml;t des Nutzers (z. B.
            Device-Fingerprinting) im Sinne des TTDSG umfasst. Die Einwilligung
            ist jederzeit widerrufbar.
          </p>

          <p>
            Wenn Ihr Browser Font Awesome nicht unterst&uuml;tzt, wird eine
            Standardschrift von Ihrem Computer genutzt. Weitere Informationen zu
            Font Awesome finden Sie und in der Datenschutzerkl&auml;rung von
            Font Awesome unter:{" "}
            <a href="https://fontawesome.com/privacy">
              https://fontawesome.com/privacy
            </a>
            .
          </p>

          <p>
            Quelle:&nbsp;
            <a href="https://www.e-recht24.de">https://www.e-recht24.de</a>
          </p>
        </SectionContent>
      </TextSection>
    </>
  );
}
